import Transform from '@ember-data/serializer/transform';

/**
 * This will allow a boolean to be NULL in addition to the boolean value.
 */
export default Transform.extend({
  /**
   * @inheritDoc
   */
  deserialize: function(serialized) {
    if (serialized == null) {
      return null;
    }

    return !!serialized;
  },

  /**
   * @inheritDoc
   */
  serialize: function(deserialized) {
    return deserialized;
  }
});
